import React, {Component} from 'react';
import { connect } from 'react-redux';
import { checkStatues } from '../../actions/auth_actions';
import { changeToChinese, changeToEnglish } from '../../actions/language_actions';

// An HOC which will navigate user back to the login
// page if the user try to reach some pages without
// being authenticated.

export default function (ComposedComponent, name) {
    class Authentication extends Component {
        static contextTypes = {
            router: React.PropTypes.object
        }

        componentWillMount() {
          this.props.checkStatues();
        }

        componentDidMount() {
          if (localStorage.getItem('lang') === 'ch') {
            this.props.changeToChinese();
          } else {
            this.props.changeToEnglish();
          }
        }

        componentWillUpdate(nextProps) {
          if (!nextProps.authenticated) {
              this.context.router.push('/login')
          }
          if (localStorage.getItem('lang') == 'ch') {
            this.props.changeToChinese();
          } else {
            this.props.changeToEnglish();
          }
        }

        render() {
            let userPermissions = this.props.userPermissions;
            if(name && userPermissions.indexOf(name) == -1) {
              return <div>no permission</div>
            }
            return <ComposedComponent {...this.props} />
        }
    }

    function mapStateToProps(state) {
        return { authenticated: state.auth.authenticated,
                 userType     : state.auth.userType,
                 selectedCompany: state.header.selectedCompany,
                 userPermissions: state.auth.userPermissions }
    }
    return connect(mapStateToProps, { changeToEnglish, changeToChinese, checkStatues })(Authentication);
}



// WEBPACK FOOTER //
// ./master/jsx/containers/Auth/require_auth.jsx